import { Navigate } from "react-router-dom";
import useAuth from "../Hooks/useAuth";
import LoadingOverlay from "../components/Loading/LoadingOverlay";

const AdminRoute = ({ children }) => {
  const { isAuthenticated, isAdmin, isAuthLoading } = useAuth();

  if (isAuthLoading || isAuthenticated === null) {
    return <LoadingOverlay />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
